import React, {useEffect} from 'react';
import AppBack from '../AppBack';
import {Button, Text, Chip, TooltipProvider, Icon} from '@cloudaper/react';

const Step4 = props => {
  const {
    validateToken,
    currentStep,
    handlePostResources,
    handleStep,
    postingResources,
    strediska,
    optionalRoles,
    roomSystemName,
  } = props;

  useEffect(() => {
    document.title = 'Kontrola - Začněte s Document Managerem';

    validateToken();
  }, [validateToken]);

  const allEmails = {
    recepcni: [],
    predschvalovatel: [],
    schvalovatel: [],
    ucetni: [],
    nahlizitel: [],
  };
  const uniqueEmails = {};
  strediska.forEach(stredisko => {
    stredisko.recepcni.chips.forEach(email => allEmails.recepcni.push(email));
    stredisko.predschvalovatel.chips.forEach(email =>
      allEmails.predschvalovatel.push(email),
    );
    stredisko.schvalovatel.chips.forEach(email =>
      allEmails.schvalovatel.push(email),
    );
    stredisko.ucetni.chips.forEach(email => allEmails.ucetni.push(email));
    stredisko.nahlizitel.chips.forEach(email =>
      allEmails.nahlizitel.push(email),
    );
  });
  uniqueEmails.recepcni = [...new Set(allEmails.recepcni)];
  uniqueEmails.predschvalovatel = [...new Set(allEmails.predschvalovatel)];
  uniqueEmails.schvalovatel = [...new Set(allEmails.schvalovatel)];
  uniqueEmails.ucetni = [...new Set(allEmails.ucetni)];
  uniqueEmails.nahlizitel = [...new Set(allEmails.nahlizitel)];

  return postingResources ? (
    <div className="appWrapper">
      <Text className="appConnectorCounter">
        <Icon className="postingResources" large name="gear-wheel" />
      </Text>

      <div className="appContent">
        <Text className="appHeading centeredText">
          Vaše skříň se právě sestavuje
        </Text>

        <br />
        <Text className="centeredText cardBodyText">
          Prosíme, nezavírejte tuto stránku.
        </Text>
      </div>
    </div>
  ) : (
    <>
      <div className="appWrapper">
        <div className="appConnectorString" />

        <Text className="appConnectorCounter">
          <Icon large name="check" />
        </Text>

        <div className="appContent appContentMedium">
          <Text className="appHeading centeredText">Kontrolní vizualizace</Text>
          <br />
          <Text className="centeredText cardBodyText">
            Toto je grafické znázornění vašich procesů. Pokud potřebujete,
            můžete se vráti na předchozí krok a provést potřebné změny. Pokud
            jste spokojení, neváhejte vstoupit do Document Manageru!
          </Text>
        </div>

        <div
          className={`appContent ${
            strediska.length > 1 ? 'appContentFullWidth' : 'appContentWide'
          }`}
        >
          <div className="processVisualization">
            <div className="col colSticky"></div>
            <div className="col">
              <div className="row">
                <Text className="col action actionDefault">
                  <div>
                    <Icon name="at" style={{marginRight: '8px'}} />
                    E-mail
                  </div>
                  <div>
                    <Icon name="scanner" style={{marginRight: '8px'}} />
                    Scan
                  </div>
                  <div>
                    <Icon
                      name="envelope-outline"
                      style={{marginRight: '8px'}}
                    />
                    Datovky
                  </div>
                </Text>
              </div>
              <div className="row">
                <Text
                  className="col centeredText cardBodyText"
                  style={{margin: '8px 0'}}
                >
                  Dokumenty můžete do Document Manageru nahrát jako soubor,
                  oskenovat
                  <br />
                  nebo poslat e-mailem na {`${roomSystemName}@cloudaper.email`}.
                </Text>
              </div>
            </div>

            <div className="col colSticky"></div>
            <div className="col">
              <div className="row">
                <Text className="col action actionSber">
                  <Icon
                    name="arrow-convergent"
                    style={{
                      color: 'blue',
                      marginRight: '8px',
                      transform: 'rotate(180deg)',
                    }}
                  />
                  Sběr
                </Text>
              </div>
            </div>

            <Text className="col colSticky shelfName">Příjem</Text>
            <div className="col">
              <div className="rowGrid">
                <div className="col">
                  <Text className="boldText">
                    <Icon large name="tray" className="trayIcon recepcniIcon" />
                    {`${roomSystemName}@cloudaper.email`}
                  </Text>
                </div>
              </div>
              <div className="rowGrid">
                <div className="col colFixMargin">
                  {uniqueEmails.recepcni.map(recepcni => (
                    <div className="emailChip">
                      <TooltipProvider tooltip={recepcni}>
                        <Chip className="recepcniChip">
                          {recepcni.split('@')[0]}@
                        </Chip>
                      </TooltipProvider>
                    </div>
                  ))}
                  {uniqueEmails.predschvalovatel.map(predschvalovatel => (
                    <div className="emailChip">
                      <TooltipProvider tooltip={predschvalovatel}>
                        <Chip className="predschvalovatelChip">
                          {predschvalovatel.split('@')[0]}@
                        </Chip>
                      </TooltipProvider>
                    </div>
                  ))}
                  {uniqueEmails.schvalovatel.map(schvalovatel => (
                    <div className="emailChip">
                      <TooltipProvider tooltip={schvalovatel}>
                        <Chip className="schvalovatelChip">
                          {schvalovatel.split('@')[0]}@
                        </Chip>
                      </TooltipProvider>
                    </div>
                  ))}
                  {uniqueEmails.nahlizitel.map(nahlizitel => (
                    <div className="emailChip">
                      <TooltipProvider tooltip={nahlizitel}>
                        <Chip className="nahlizitelChip" icon="eye">
                          {nahlizitel.split('@')[0]}@
                        </Chip>
                      </TooltipProvider>
                    </div>
                  ))}
                </div>
              </div>
              <div className="row">
                <Text
                  className={`col action ${
                    optionalRoles.predschvalovatel
                      ? 'actionTridi'
                      : 'actionPredschvaluji'
                  }`}
                >
                  <Icon
                    name="arrow-divergent"
                    style={{
                      color: 'blue',
                      marginRight: '8px',
                      transform: 'rotate(180deg)',
                    }}
                  />
                  Třídí
                </Text>
              </div>
            </div>

            {strediska.length > 1 && (
              <>
                <div className="col colSticky"></div>
                <div className="col">
                  <div
                    className="rowGrid strediskaNames"
                    style={{
                      gridTemplateColumns: `repeat(${strediska.length}, minmax(200px, 1fr))`,
                    }}
                  >
                    {strediska.map(stredisko => (
                      <Text
                        className="col boldText centeredText"
                        key={`${stredisko.stredisko}_nazev`}
                      >
                        {stredisko.stredisko}
                      </Text>
                    ))}
                  </div>
                </div>
              </>
            )}

            {optionalRoles.predschvalovatel && (
              <>
                <Text className="col colSticky shelfName">
                  Ke schválení 1. úr.
                </Text>
                <div className="col">
                  <div
                    className="rowGrid"
                    style={{
                      gridTemplateColumns: `repeat(${strediska.length}, minmax(200px, 1fr))`,
                    }}
                  >
                    {strediska.map(stredisko => (
                      <div
                        className="col colChips"
                        key={`${stredisko.stredisko}_ke_schvaleni_1`}
                      >
                        <div>
                          <Icon
                            large
                            name="binder"
                            className="binderIcon predschvalovatelIcon"
                          />
                        </div>
                        <div>
                          {stredisko.predschvalovatel.chips.map(
                            predschvalovatel => (
                              <div className="emailChip">
                                <TooltipProvider tooltip={predschvalovatel}>
                                  <Chip className="predschvalovatelChip">
                                    {predschvalovatel.split('@')[0]}@
                                  </Chip>
                                </TooltipProvider>
                              </div>
                            ),
                          )}
                          {stredisko.schvalovatel.chips.map(schvalovatel => (
                            <div className="emailChip">
                              <TooltipProvider tooltip={schvalovatel}>
                                <Chip className="schvalovatelChip">
                                  {schvalovatel.split('@')[0]}@
                                </Chip>
                              </TooltipProvider>
                            </div>
                          ))}
                          {stredisko.nahlizitel.chips.map(nahlizitel => (
                            <div className="emailChip">
                              <TooltipProvider tooltip={nahlizitel}>
                                <Chip className="nahlizitelChip" icon="eye">
                                  {nahlizitel.split('@')[0]}@
                                </Chip>
                              </TooltipProvider>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="row">
                    <Text className="col action actionPredschvaluji">
                      <Icon
                        name="arrow-down"
                        style={{color: 'green', marginRight: '8px'}}
                      />
                      Schvalují
                    </Text>
                  </div>
                </div>
              </>
            )}

            <Text className="col colSticky shelfName">
              {optionalRoles.predschvalovatel
                ? 'Ke schválení 2. úr.'
                : 'Ke schválení'}
            </Text>
            <div className="col">
              {optionalRoles.predschvalovatel && (
                <div className="row">
                  <Text className="col action actionVraciPredschvalovateli">
                    <Icon
                      name="arrow-up"
                      style={{color: 'red', marginRight: '8px'}}
                    />
                    Vrací
                  </Text>
                </div>
              )}
              <div
                className="rowGrid"
                style={{
                  gridTemplateColumns: `repeat(${strediska.length}, minmax(200px, 1fr))`,
                }}
              >
                {strediska.map(stredisko => (
                  <div
                    className="col colChips"
                    key={`${stredisko.stredisko}_ke_schvaleni_2`}
                  >
                    <div>
                      <Icon
                        large
                        name="binder"
                        className="binderIcon schvalovatelIcon"
                      />
                    </div>
                    <div>
                      {stredisko.schvalovatel.chips.map(schvalovatel => (
                        <div className="emailChip">
                          <TooltipProvider tooltip={schvalovatel}>
                            <Chip className="schvalovatelChip">
                              {schvalovatel.split('@')[0]}@
                            </Chip>
                          </TooltipProvider>
                        </div>
                      ))}
                      {stredisko.nahlizitel.chips.map(nahlizitel => (
                        <div className="emailChip">
                          <TooltipProvider tooltip={nahlizitel}>
                            <Chip className="nahlizitelChip" icon="eye">
                              {nahlizitel.split('@')[0]}@
                            </Chip>
                          </TooltipProvider>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              <div className="row">
                <Text className="col action actionSchvaluji">
                  <Icon
                    name="arrow-down"
                    style={{color: 'green', marginRight: '8px'}}
                  />
                  Schvalují
                </Text>
              </div>
            </div>

            <Text className="col colSticky shelfName">Schválené doklady</Text>
            <div className="col">
              <div className="row">
                <Text className="col action actionVraciSchvalovateli">
                  <Icon
                    name="arrow-up"
                    style={{color: 'red', marginRight: '8px'}}
                  />
                  Vrací
                </Text>
              </div>
              <div
                className="rowGrid"
                style={{
                  gridTemplateColumns: `repeat(${strediska.length}, minmax(200px, 1fr))`,
                }}
              >
                {strediska.map(stredisko => (
                  <div
                    className="col colChips"
                    key={`${stredisko.stredisko}_schvalene_doklady`}
                  >
                    <div>
                      <Icon
                        large
                        name="binder"
                        className="binderIcon ucetniIcon"
                      />
                    </div>
                    <div>
                      {stredisko.ucetni.chips.map(ucetni => (
                        <div className="emailChip">
                          <TooltipProvider tooltip={ucetni}>
                            <Chip className="ucetniChip">
                              {ucetni.split('@')[0]}@
                            </Chip>
                          </TooltipProvider>
                        </div>
                      ))}
                      {stredisko.schvalovatel.chips.map(schvalovatel => (
                        <div className="emailChip">
                          <TooltipProvider tooltip={schvalovatel}>
                            <Chip className="schvalovatelChip" icon="eye">
                              {schvalovatel.split('@')[0]}@
                            </Chip>
                          </TooltipProvider>
                        </div>
                      ))}
                      {stredisko.nahlizitel.chips.map(nahlizitel => (
                        <div className="emailChip">
                          <TooltipProvider tooltip={nahlizitel}>
                            <Chip className="nahlizitelChip" icon="eye">
                              {nahlizitel.split('@')[0]}@
                            </Chip>
                          </TooltipProvider>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              <div className="row">
                <Text className="col action actionArchivuji">
                  <Icon
                    name="arrow-down"
                    style={{color: 'blue', marginRight: '8px'}}
                  />
                  Archivují
                </Text>
              </div>
            </div>

            <Text className="col colSticky shelfName">Archiv dokladů</Text>
            <div className="col">
              <div
                className="rowGrid"
                style={{
                  gridTemplateColumns: `repeat(${strediska.length}, minmax(200px, 1fr))`,
                }}
              >
                {strediska.map(stredisko => (
                  <div
                    className="col colChips"
                    key={`${stredisko.stredisko}_archiv_dokladu`}
                  >
                    <div>
                      <Icon
                        large
                        name="binder"
                        className="binderIcon nahlizitelIcon"
                      />
                    </div>
                    <div>
                      {stredisko.ucetni.chips.map(ucetni => (
                        <div className="emailChip">
                          <TooltipProvider tooltip={ucetni}>
                            <Chip className="ucetniChip" icon="eye">
                              {ucetni.split('@')[0]}@
                            </Chip>
                          </TooltipProvider>
                        </div>
                      ))}
                      {stredisko.schvalovatel.chips.map(schvalovatel => (
                        <div className="emailChip">
                          <TooltipProvider tooltip={schvalovatel}>
                            <Chip className="schvalovatelChip" icon="eye">
                              {schvalovatel.split('@')[0]}@
                            </Chip>
                          </TooltipProvider>
                        </div>
                      ))}
                      {stredisko.nahlizitel.chips.map(nahlizitel => (
                        <div className="emailChip">
                          <TooltipProvider tooltip={nahlizitel}>
                            <Chip className="nahlizitelChip" icon="eye">
                              {nahlizitel.split('@')[0]}@
                            </Chip>
                          </TooltipProvider>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="appConnectorButtonWrapper">
          <Button
            className="appConnectorButton"
            kind="primary"
            onClick={handlePostResources}
            raised
          >
            Vstoupit do Document Manageru
          </Button>
        </div>

        {currentStep === 4 && <AppBack onClick={() => handleStep(3)} />}

        <div className="appConnectorStringEnd" />
      </div>
    </>
  );
};

export default Step4;
